import { render } from "./ChoosePaymentMethod.vue?vue&type=template&id=2c054bec&ts=true"
import script from "./ChoosePaymentMethod.vue?vue&type=script&lang=ts"
export * from "./ChoosePaymentMethod.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner});
